module.exports = __webpack_public_path__ + "static/media/food-white.833221e4.svg";